"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultContext = void 0;
var react_1 = require("react");
var logError = function () {
    console.error('AuthContext has not be initialized be sure it is wrapped in the <AuthContextProvider>');
    return new Promise(function (_, reject) { return reject('not_yet_initialized'); });
};
exports.defaultContext = {
    status: 'not_initialized',
    getDecodedToken: logError,
    getAccessToken: logError,
    getPermissions: logError,
    invalidate: logError,
};
var AuthContext = (0, react_1.createContext)(exports.defaultContext);
exports.default = AuthContext;
//# sourceMappingURL=AuthContext.js.map